import { render, staticRenderFns } from "./CmgNutritionCalculatorMealBuilderGroup.vue?vue&type=template&id=3f268a3a&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-meal-builder-group.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-meal-builder-group.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorMealBuilderGroup.vue?vue&type=style&index=0&id=3f268a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f268a3a",
  null
  
)

export default component.exports